<template>
    <div class="company-info">
<!--        <div class="company-info-title">-->
<!--            <span>-->
<!--                {{obj.companyname}}-->
<!--            </span>-->

<!--            <span>-->
<!--                {{obj.raddinfo1}}-{{obj.raddinfo2}}-->
<!--            </span>-->
<!--        </div>-->

        <div class="content-box">
            <div class="img-box">
                <img :src="imgSrc" class="preview-img">
            </div>

            <div class="product-info-box">
                <div>
                    <div class="title-box">
                        <span>{{obj.productname}}</span>
                    </div>

<!--                    <div class="text-box">-->
<!--                        <span>{{obj.description}}</span>-->
<!--                    </div>-->
                </div>

                <div class="shop-info">
                    <div>
                        <span class="price-span">$ {{obj.cost}}</span>
                    </div>

                    <div>
                        <el-button type="primary" text @click="goShopEvent" tkey="前往展臺">{{i18n.tkey("lang_go_booth")}}</el-button>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script setup>
    import {computed, getCurrentInstance, inject} from 'vue'
    import myUtil from "@/util/util";

    let { proxy } = getCurrentInstance();

    const emits = defineEmits(['click-go-shop'])
    const props = defineProps(['obj'])

    const i18n = inject("i18n")

    const { phoneGoFloorCallback } = inject('threeHallFunc', { phoneGoFloorCallback: () => {} })

    const imgSrc = computed(() => {
        let src = ""

        const obj = props.obj

        if (null != obj){
            src = myUtil.generateProductImg(obj)
        }

        return src
    })

    function goShopEvent() {
        phoneGoFloorCallback(props.obj.raddinfo1, props.obj.raddinfo2)
        emits("click-go-shop", props.obj.raddinfo1, props.obj.raddinfo2)
    }
</script>

<style scoped>
.company-info {
    border: 1px #DCDFE6 solid;
    line-height: 2;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 5px;
}

.company-info:nth-child(even) {
    background: #f9f9f9;
}

.company-info-title {
    text-align: left;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.shop-info {
    //display: flex;
    //align-items: center;
    //justify-content: space-between;
    text-align: center;
    line-height: 1.5;
}

.price-span {
    color: #e83f33;
    font-weight: 600;
}

.content-box {
    //display: flex;
}

.img-box {
    width: 100%;
    padding-top: 100%;
    position: relative;
    //width: 80px;
    //height: 80px;
}

.preview-img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px #d6d6d6 solid;
    position: absolute;
    left: 0;
    top: 0;
}

.product-info-box {
    //width: calc(100% - 80px);
    width: 100%;
    box-sizing: border-box;
    padding-left: 5px;
}

.product-info-box .title-box {
    font-size: 14px;
    text-align: center;
    line-height: 2;
    //padding-bottom: 5px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
}

.product-info-box .text-box {
    font-size: 12px;
    text-align: left;
    line-height: 1.5;
    color: #666;
    min-height: 3em;
}
</style>